import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        welcome: "Welcome",
        service_insights: "Service Insights",
        confirmed: "Confirmed",
        cancelled: "Cancelled",
        smr_bots: "SMR BOTS",
        psf_bots: "PSF BOTS",
        abc_bots: "ABC BOTS",
        active_service: "Active Service",
        other_service: "Other Service",
        view_details: "View Details",
        smr_bots_title: "SMR + BOTS ( Chat + Voice )",
        smr_bots_description:
          "SMR BOTS pops up when you land on our home page and if you tell her you are interested in possibly working with SMR, she passes you to a live agent. The agent has real-time access to my calendar and will schedule an appointment for the two of us right there and then.",
        psf_bots_title: "PSF + BOTS ( Chat + Voice )",
        psf_bots_description:
          "SMR BOTS pops up when you land on our home page and if you tell her you are interested in possibly working with SMR, she passes you to a live agent. The agent has real-time access to my calendar and will schedule an appointment for the two of us right there and then.",
        all_in_one_service_plans: "All-in-one Service Plans",
        home_account_details: "Account Details",
        total_active_service_plans: "Total {{count}} Active Service Plans",
        total_other_service_plans: "Total {{count}} Other Service Plans",
        home: "Home",
        active_services: "Active Services",
        other_services: "Other Services",
        available_balance: "Available Balance",
        showing_data: "Showing data",
  to: "to",
  entries: "entries",

        //Service Page

        key_features: "Key Features",
        our_top_benefits: "Our Top Benefits",
        service_overview: "Service Overview",
        service_amount: "Service Amount",
        service_status: "Service Status",
        report_s: "Report",
        invoice_s: "Invoice",
        learn_more: "Learn More",
        smr_bots_key_features:
          "SMR BOT Key Feature:Empower your business with an AI chat bot that speaks multiple languages and answers across channels. Consolidate messages from email, chat, WhatsApp, Telegram, SMS, and Facebook into one unified inbox, so you don't have to juggle between tools. Our AI chat bot smartly identifies when a query requires human expertise and seamlessly transfers the conversation to a live agent. Consolidate messages from email, chat, WhatsApp, Telegram, SMS, and Facebook into one unified inbox, so you don't have to juggle between tools. Our AI chat bot smartly identifies when a query requires human expertise and seamlessly transfers the conversation to a live agent.",
        smr_bots_top_benefits:
          "SMR BOT Top Benefits:Empower your business with an AI chat bot that speaks multiple languages and answers across channels. Consolidate messages from email, chat, WhatsApp, Telegram, SMS, and Facebook into one unified inbox, so you don't have to juggle between tools. Our AI chat bot smartly identifies when a query requires human expertise and seamlessly transfers the conversation to a live agent. Consolidate messages from email, chat, WhatsApp, Telegram, SMS, and Facebook into one unified inbox, so you don't have to juggle between tools. Our AI chat bot smartly identifies when a query requires human expertise and seamlessly transfers the conversation to a live agent.",
        psf_bots_key_features:
          "PSF BOT Key Feature:Empower your business with an AI chat bot that speaks multiple languages and answers across channels. Consolidate messages from email, chat, WhatsApp, Telegram, SMS, and Facebook into one unified inbox, so you don't have to juggle between tools. Our AI chat bot smartly identifies when a query requires human expertise and seamlessly transfers the conversation to a live agent. Consolidate messages from email, chat, WhatsApp, Telegram, SMS, and Facebook into one unified inbox, so you don't have to juggle between tools. Our AI chat bot smartly identifies when a query requires human expertise and seamlessly transfers the conversation to a live agent.",
        psf_bots_top_benefits:
          "PSF BOT Top Benefits:Empower your business with an AI chat bot that speaks multiple languages and answers across channels. Consolidate messages from email, chat, WhatsApp, Telegram, SMS, and Facebook into one unified inbox, so you don't have to juggle between tools. Our AI chat bot smartly identifies when a query requires human expertise and seamlessly transfers the conversation to a live agent. Consolidate messages from email, chat, WhatsApp, Telegram, SMS, and Facebook into one unified inbox, so you don't have to juggle between tools. Our AI chat bot smartly identifies when a query requires human expertise and seamlessly transfers the conversation to a live agent.",
        service_amount_title: "Total {{count}} service plans",
        sorting: "Sorting",
        cost_low_to_high: "Cost (Low to High)",
        cost_high_to_low: "Cost (High to Low)",
        minutes_low_to_high: "Minutes (Low to High)",
        minutes_high_to_low: "Minutes (High to Low)",
        chats_low_to_high: "Chats (Low to High)",
        chats_high_to_low: "Chats (High to Low)",
        plan_cost: "PLAN COST",
        total_minutes: "TOTAL MINUTES",
        whatsapp_chats: "WhatsApp CHATS",
        add_service: "Add Service",
        plan_name:"Plan Name",
        registerAutoDebit: "Register for Auto-Debit?",
        confirmationText: "This is a confirmation that you have registered for Auto Debit. Do you want to continue?",
        keepManual: "Keep it Manual",

  autoDebitSuccessTitle: "Auto Debit Success!",
  autoDebitSuccessMessage: "Your Auto Debit registration has been completed successfully.",
  alert: "Alert",
  disableAutoDebitMessage: "Disable Auto Debit before enabling a new plan.",
  okButton: "OK",

        //Popup Purchase
        tax_invoice: "Tax Invoice of {{planName}}!",
        service_plan: "Service Plan",
        service_name: "Service Name",
        purchase_date: "Purchase Date",
        invoice_country: "Invoice Country",
        country_name: "India",
        unit_price: "Unit Price",
        gst_percentage: "GST%",
        gst_amount: "GST Amount",
        total_amount: "Total Amount",
        cancel: "Cancel",
        confirm: "Confirm",

        //Terms & Conditions
        terms_conditions: "Terms & Conditions",

        terms_paragraph:
          '{\n  "sections": [\n    {\n      "title": "1. Introduction and Definitions",      "content": [\n        "Maruti Suzuki India Limited (hereafter referred as \'MSIL\') offers digital services subscription plans for Maruti Suzuki Authorized Service Stations (hereafter referred as \'MASS\') through MASS Business Zone Portal (the portal) on a prepaid basis."\n      ]\n    },\n    {\n      "title": "2. Purpose and Acceptance of Services",\n      "content": [\n        "MASS understands & agrees that the objective of these services is to digitally support MASS workshop business operations."\n      ]\n    },\n    {\n      "title": "3. Payment and Authorization for Deduction",\n      "content": [\n        "MASS accepts and allows MSIL to deduct funds from MASS financial accounts and operate services on behalf of MASS based on the opted service package and applicable taxes at any time."\n      ]\n    },\n    {\n      "title": "4. Service Operation and Termination",\n      "content": [\n        "MASS allows MSIL to permit its business partners/vendors to operate digital services on behalf of MASS as per the subscription opted by MASS.",\n        "MASS accepts that services once subscribed cannot be paused, halted, or terminated by MASS until the completion of the tenure of services.",\n        "However, MSIL reserves the right to terminate the services at any time without requiring to intimate MASS beforehand."\n      ]\n    },\n    {\n      "title": "5. Service Rules, Schedule, and Modifications",\n      "content": [\n        "MASS accepts the digital services to run as per rules, schedule, and process at the discretion of MSIL.",\n        "Furthermore, by virtue of being on the MBZ portal, MASS agrees to accept any changes/modifications in the rules, schedule, and process of digital offerings at any time with or without any intimation by MSIL."\n      ]\n    },\n    {\n      "title": "6. Service Renewal",\n      "content": [\n        "Based on the service package opted, MASS would also permit MSIL to renew services with all applicable debit fees until MASS manually decides to opt out."\n      ]\n    },\n    {\n      "title": "7. Scope of Voice and Chat Bot Services",\n      "content": [\n        "Voice + Chat bot will call all customers for whom SMR/Service is due or for whom a valid mobile number is available in Dealer Management System software (DMS) while this plan is active."\n      ]\n    },\n    {\n      "title": "8. Lead and Feedback Sharing",\n      "content": [\n        "The leads/feedback generated would be shared with MASS over the DMS system or any portals shared by MSIL and not on the MBZ portal."\n      ]\n    },\n    {\n      "title": "9. Data Analysis and Customer Contact Authorization",\n      "content": [\n        "MASS allows for its database to be analyzed, and customers to be contacted by the AI-based VOICE + CHAT BOT system in the activity on their behalf."\n      ]\n    },\n    {\n      "title": "10. Performance Disclaimer",\n      "content": [\n        "MASS understands and accepts that the performance of Chat/Voice bots and leads/feedback generated is based on responses of customers in the database.",\n        "Since performance is dependent on the quality of the database being maintained, MSIL claims no guarantee of the performance of digital offerings at any point in time.",\n        "MASS acknowledges that any incidents or damages resulting from digital system failures shall be the sole responsibility of MASS."\n      ]\n    },\n    {\n      "title": "11. Campaign Offer Updates",\n      "content": [\n        "For this activity, MASS can update offers on their dedicated Campaign Portals shared by MSIL for MASS."\n      ]\n    },\n    {\n      "title": "12. MASS Responsibility for Leads and Feedback",\n      "content": [\n        "MASS understands and agrees that leads/feedback generated by the VOICE + CHAT BOT shall, in turn, assist it to boost its service business load, revenue, and customer satisfaction.",\n        "However, MASS shall remain responsible for the responses received, follow-up, and conversion of leads/resolution of feedback concerns."\n      ]\n    },\n    {\n      "title": "13. MSIL\'s Right to Modify Campaign Details",\n      "content": [\n        "MSIL reserves the right to change the data, terms & conditions, details, and duration of the campaign at its sole discretion with or without prior intimation to MASS."\n      ]\n    },\n    {\n      "title": "14. Compliance with Laws and Regulations",\n      "content": [\n        "The compliance of TRAI, Telecom companies & META (WhatsApp) Regulations and all other applicable laws are to be adhered to by MASS who are availing the services.",\n        "Any query/dispute from the regulatory authorities shall be resolved by MASS."\n      ]\n    },\n    {\n      "title": "15. Queries and Support Contact",\n      "content": [\n        "For any doubts/queries that MASS may have, MASS shall reach out to MSIL Regional offices/Service teams to discuss the same."\n      ]\n    },\n    {\n      "title": "16. General Applicability and Contact Information",\n      "content": [\n        "These offers will be applicable for both CHAT & VOICE Bot.",\n        "For any query, please contact your MSIL Regional Office."\n      ]\n    },\n    {\n      "title": "17. Do Not Disturb (DND) Registration",\n      "content": [\n        "To mark any phone number in ‘Do Not Disturb’ for stopping Service Marketing Calls/Chats, email the customer details and phone number to cs@rezo.ai & support@rezo.ai."\n      ]\n    },\n    {\n      "title": "18. General Legal Provisions",\n      "content": [\n        "MASS is responsible for adhering to all applicable data privacy and security regulations and for maintaining the privacy, security, confidentiality, and integrity of all information accessible from digital sources at its end.",\n        "MASS shall indemnify MSIL from any disputes arising from the services.",\n        "In the event of any dispute arising out of the services envisaged under these terms and conditions, the terms and conditions agreed under the MASS Agreement shall be applicable.",\n        "The terms and conditions contained herein can be changed by MSIL at any time without prior intimation.",\n        "The same would be updated in the portal for reference."\n      ]\n    }\n  ]\n}',

        agree_terms: "I read and agree to terms and conditions",
        accept: "Accept",

        //OrderConfirmationPopup
        thank_you_order:
          "Thank you for your order. Your service would start shortly!",
        order_details: "Order Details",
        service_purchased: "Service Purchased",
        connected_total_minutes: "Connected Total Minutes",
        minutes: "Minutes",
        whatsapp: "WhatsApp",
        chat: "Chat",
        order_id: "Order ID",
        order_date: "Order Date",
        order_number: "Order Number",
        total_cost: "Total Cost",

        //Service Status
        current_service_status: "Current Service Status",
        recharge_plan_name: "RECHARGE PLAN NAME",
        total_connected_call_minutes: "CONNECTED CALL (MINUTES) / TOTAL",
        total_delivered_chats: "DELIVERED (CHATS) / TOTAL",
        pro_plan_name: "Pro Plan",
        balance_call: "Balance (Call)",
        balance_chats: "Balance (Chats)",
        minutes_left: "{{total}} minutes left",
        chats_left: "{{total}} chats left",
        out_of_total: " out of total ",
        chats: "Chats",
         no_data_found:"No data found",

        //Recent Transaction Report 
        transaction_reports: "Transaction Reports",
date_start: "Date Start",
date_end: "Date End",
all_services: "All Services",
view_report: "View Report",
export_to_excel: "Export to",
export_to_pdf: "Export to",
transaction_summary: "Transaction Summary",
all_dates: "All Dates",
for_service: "For Service",
transaction_date: "Transaction Date",
transaction_id: "Transaction ID",
plan: "Plan",
gst: "GST",
amount: "Amount",
total_debit: "Total Debit",
closing_balance: "Closing Balance",
auto_debit: "Auto Debit",
previous: "Previous",
next: "Next",
no_data_export: "No data available to export.",
transaction_report_title: "Transaction Report",
amount_currency: "Amount (₹)",
total_debit_currency: "Total Debit (₹)",
closing_balance_currency: "Closing Balance (₹)",
 select_date_range: "Select Date Range",
 date_range: "Date Range",
 all_plans:"All Plans",


 //Admin Dashboard 
  "TOTAL_MASS_DMS": "TOTAL MASS (DMS)",
  "VIEW_TOTAL_MASS_USERS_DMS": "VIEW TOTAL MASS USERS (DMS)",
  "TOTAL_ONBOARDED_MASS": "TOTAL ONBOARDED MASS",
  "VIEW_TOTAL_ONBOARDED_MASS": "VIEW TOTAL ONBOARDED MASS",
  "UP_FROM_LAST_MONTH": "▲ 2.7% Up from last month",
  "TOTAL_MASS_ACTIVE": "TOTAL MASS (ACTIVE SERVICE)",
  "VIEW_ALL_ACTIVE": "VIEW ALL ACTIVE MASS USERS",
  "PENDING_REQUESTS": "PENDING REQUESTS",
  "MANAGE_REQUESTS": "MANAGE REQUESTS",
  "SERVICE_ABOUT_TO_EXHAUST": "ALL MASS (SERVICE ABOUT TO EXHAUST)",
  "VIEW_SERVICE_ABOUT_TO_EXHAUST": "VIEW MASS (SERVICE ABOUT TO EXHAUST)",
  "ACTIVE_SERVICE_PLANS": "ACTIVE SERVICE PLANS",
  "VIEW_ALL_SERVICE_PLANS": "VIEW ALL SERVICE PLANS",
  "TOTAL_REVENUE": "TOTAL REVENUE",
  "VIEW_REPORT": "VIEW REPORT",
  "UP_FROM_LAST_QUARTER": "▲ 1.6% Up from last quarter",
  dashboard:"Dashboard",
   "revenueFY": "Revenue FY {{year}}",
  "month": "Month",
  "quarter": "Quarter",
  "lineChart": "Line Chart",
  "barChart": "Bar Chart",
  "tooltipLabel": "{{label}}: ₹{{value}}",

  //Admin all services 

  "allServices": "All Services",
  "status": "Status",
  "all": "All",
  "active": "Active",
  "inactive": "Inactive",
  "serviceName": "Service Name",
  "servicePlan": "Service Plan",
  "basic": "Basic",
  "basicPlusPlus": "Basic ++",
  "proPlan": "Pro Plan",
  "categories": "Categories",
  "addPlan": "Add Plan",
  "addService": "Add Service",
  "serviceInfo": "Service Info",
  "editServices": "Edit Services",
  "editPlan": "Edit Plan",
  "updatePlan": "Update Plan",
  "deletePlan": "Delete Plan",
  "deactivate": "Deactivate",
  "category": "Category",
  "deleteService": "Delete Services",
  "activationDate": "Activation Date",
  "plans": "Plans",
  "priceInclGST": "Price (incl. GST)",
  "planStatus": "Plan Status",
  "showingData": "Showing data {{start}} to {{end}} entries",
  "aichatbot": "AI ChatBot",
  "voicechatbot": "Voice ChatBot",
  "chatbot": "ChatBot",
  "smschatbot": "SMS ChatBot",
  "smrchatbot": "SMR ChatBot",
  "edit":"Edit",


  // Add new Service
  "ADD_NEW_SERVICE_TITLE": "Add New Service",
  "SERVICE_DETAILS": "Service Details",
  "SERVICE_PLANS": "Service Plans",
  "ADD_PLANS_BUTTON": "+ Add Plans",
  "BACK_BUTTON": "Back",
  "SERVICE_DETAIL_INFORMATION_TITLE": "Service Detail Information",
  "SERVICE_NAME_LABEL": "Service Name",
  "SERVICE_NAME_REQUIRED": "Service name is required.",
  "SERVICE_NAME_TEXT_ONLY": "Please enter text only (alphabets and spaces).",
  "SERVICE_CATEGORY_LABEL": "Service Category",
  "SERVICE_CATEGORY_REQUIRED": "Service category is required.",
  "SELECT_CATEGORY_OPTION": "Select a category",
  "DETAILED_DESCRIPTION_LABEL": "Detailed Description",
  "DETAILED_DESCRIPTION_PLACEHOLDER": "A detailed description of the service helps customers to learn more about the service.",
  "DETAILED_DESCRIPTION_REQUIRED": "Detailed description is required.",
  "KEY_FEATURES_LABEL": "Key Features",
  "KEY_FEATURES_PLACEHOLDER": "A detailed key features of the service helps customers to learn more about the service.",
  "KEY_FEATURES_REQUIRED": "Key Features is required",
  "TOP_BENEFITS_LABEL": "Top Benefits",
  "TOP_BENEFITS_PLACEHOLDER": "A detailed top benefits of the service helps customers to learn more about the service.",
  "TOP_BENEFITS_REQUIRED": "Top Benefits is required",
  "CANCEL_BUTTON": "Cancel",
  "DRAFT_BUTTON": "Draft",
  "CONTINUE_BUTTON": "Continue",
  "DRAFTING_SERVICE": "Drafting Service:",
  "PUBLISHING_SERVICE": "Publishing Service:",

  //Add service Plans
  "servicePlanInformation": "Service Plan Information",
  "planName": "Plan Name",
  "planNameRequired": "Plan name is required",
  "planNameTextOnly": "Please enter text only",
  "totalCallingMinutes": "Total Calling Minutes",
  "totalMessages": "Total Messages",
  "productPrice": "Product Price",
  "productPriceRequired": "Product price is required and must be a whole number.",
  "draft": "Draft",
  "publish": "Publish",


  //Admin notification page
   "notificationsSettings": "Notification Setting",
  "serviceUsageNotification": "MASS ADMIN will get a notification message when service usage is between",
  "percentageRange30_49": "30% to 49%",
  "percentageRange50_89": "50% to 89%",
  "percentageRange90_100": "90% to 100%",
  "email": "Email",
  "sms": "SMS",
  "save": "Save",
  "subscriptionRequestNotification": "MASS ADMIN will get a notification message when subscription request is",
  "approved": "approved",
  "pending": "pending",
  "rejected": "rejected",

  //Offer and Promotions
  "offersAndPromotions": "Offers and Promotions",
  "images": "Images",
  "videos": "Videos",
  "offersAndPromotionCaption": "Offers and Promotion Caption",
  "chatBot": "Chat Bot",
  "newOffer": "New Offer!",
  "limitedTimePromotion": "Limited Time Promotion",
  "selectAndUploadImage": "Select and Upload Image",
  "chooseFileAndDropHere": "Choose a file and drop it here",
  "imageFileRequirements": "Only .jpeg, .jpg, PDF files. Max size: 5MB.",
  "browseFile": "Browse File",
  "upload": "Upload",
  "uploadedImage": "Uploaded Image",
  "noImageUploadedYet": "No image uploaded yet.",
  "continue": "Continue",
  "captionRequired": "Please select a caption.",
  "imageUploadRequired": "Please select an image to upload.",
  "invalidFileTypeOrSize": "Invalid file type or size. Only .jpeg, .jpg, and .png files up to 5MB are allowed.",
  "uploadImageToSaveDraft": "Please upload an image to save as draft.",
  "uploadImageToContinue": "Please upload an image to continue.",
  "bytes": "Bytes",
  "kb": "KB",
  "mb": "MB",
  "gb": "GB",
  "tb": "TB",

  // Offer and promotion video
  "videoType": "Video Type",
  "selectVideoType": "Select Video Type",
  "youtube": "Youtube",
  "enterVideoURL": "Enter video URL",
  "videoTypeRequired": "Please select a Video Type.",
  "youtubeURLRequired": "Please enter a Video URL for Youtube.",
  "fileOrURLRequired": "Please upload a video file or enter a Video URL.",
  "correctErrorsBelow": "Please correct the errors below.",
  "publishedSuccessful": "Published Successful!",
  "noVideoUploadedYet": "No video uploaded yet.",
  "videoFileRequirements": "Only .mp4, .mov files. Max size: 10MB.",
  "selectFileToUpload": "Please select a file to upload.",
  "selectAndUploadVideo":"Select and Upload Video",
"pendingOnboardingRequests": "Pending Onboarding Requests",
  "massName": "MASS Name",
  "massCode": "MASS Code",
  "region": "Region",
  "onboardingDate": "Onboarding Date",
  "actions": "Actions",
  "approve": "Approve",
  "deny": "Deny",
  "approveAll": "Approve All",
  "denyAll": "Deny All",
  "noPendingRequests": "No pending onboarding requests.",
  "viewAllRequests": "VIEW ALL REQUESTS",
  "approveUsers": "Approve User(s)?",
  "denyUsers": "Deny User(s)?",
  "requestsSelected": "{{count}} request selected.",
  "requestsSelectedPlural": "{{count}} requests selected.",
  "doYouWantTo": "Do you want to {{actionType}}?",
   "denied": "Denied",



    serviceCategory: "Service Category",
    detailedDescription: "Detailed Description",
    keyFeatures: "Key Features",
    topBenefits: "Top Benefits",
    serviceNameRequired: "Service name is required.",
    serviceNameTextOnly: "Please enter text only (alphabets and spaces).",
    serviceCategoryRequired: "Service category is required.",
    detailedDescriptionRequired: "Detailed description is required.",
    keyFeaturesRequired: "Key Features is required",
    topBenefitsRequired: "Top Benefits is required",
    addNewService: "Add New Service",
    serviceDetails: "Service Details",
    servicePlans: "Service Plans",
    addPlans: "+ Add Plans",
    back: "Back",
    serviceDetailInformation: "Service Detail Information",
    placeholderDescription: "A detailed description of the service helps customers to learn more about the service.",
    placeholderKeyFeatures: "A detailed key features of the service helps customers to learn more about the service.",
    placeholderTopBenefits: "A detailed top benefits of the service helps customers to learn more about the service.",
    selectCategory: "Select a category",



        //Report
        report_type_label: "Report Type:",
        usage_reports_option: "Usage Reports",
        apply_button: "Apply",
        serial_no_label: "Sr",
        plan_name_label: "Plan Name",
        cost_of_plan_label: "Cost of Plan",
        initial_recharge_label: "Initial Recharge",
        usage_label: "Usage",
        balance_label: "Balance",
        usage_report_title: "Usage Reports",
        usage_report_filename: "Usage Report",
        usage_report_sheet_name: "Usage Report",
        date_format: "dd MMM yyyy",
        performance_report_data: "Performance Report Data",
        no_data_available: "No data available for this report type.",
        basic_plan_name: "Basic",
        basic_plus_plan_name: "Basic ++",
        usage_reports_label: "Usage Reports",

        pro_plus_plan_name: "Pro ++",
        minutes_label: "{{value}} Minutes",
        no_data_export_message: "No Data Found",
        report_titles: {
          usage_reports: "Usage Reports",
          performance_report: "Performance Report",
        },


        service_usage_report: "Service Usage Report",
        "deleteServices": "Delete Services",
        inactive_mass_report: "Inactive MASS Report",
        detailed_account_status: "MASS Account Status",
        financial_report: "Financial Report",
        financial_report_mass_code: "MASS Code",
        financial_report_mass_name: "MASS Name",
        financial_report_service_name: "Service Name",
        financial_report_invoice_number: "Invoice Number",
        financial_report_invoice_date: "Invoice Date",
        financial_report_basic_amount: "Basic Amount",
        financial_report_igst_amount: "IGST Amount",
        financial_report_sgst_amount: "SGST Amount",
        financial_report_cgst_amount: "CGST Amount",
        financial_report_total_amount: "Total Amount",
        financial_report_gst_number: "GST Number of MASS",
        financial_report_plan_name: "Plan Name",
        financial_report_plan_value: "Plan Value (Plan Price)",
        financial_report_plan_date: "Plan Date",
        financial_report_minutes_provided: "Minutes Provided",
        financial_report_messages_provided: "Messages Provided",
        financial_report_sheet_name: "Financial Report Data",
        financial_report_filename: "financial_report",
        mass_account_status: "Detailed Account Status",
        mass_name_label: "MASS Name",
        mobile_label: "Mobile",
        region_label: "Region",
        service_name_label: "Service Name",
        mass_code_label: "MASS Code",
        status_label: "Status",
        order_date_label: "Order Date",
        release_date_label: "Release Date",
        end_date_label: "End Date",
        price_label: "Price",
        auto_debit_label: "Auto Debit",
        yes: "Yes",
        no: "No",
        last_activity_label: "Last Activity",
        inactivity_reason_label: "Inactivity Reason",
        no_activity: "No Activity",
        account_balance_label: "Account Balance",
        account_balance_timestamped_label: "Account Balance (Timestamped)",
        no_of_active_services_label: "No. of Active Services",
        services_report_title: "Services Report",
        services_report_sheet_name: "Services Data",
        services_report_filename: "services_report",
        inactive_report_title: "Inactive MASS Report",
        inactive_report_sheet_name: "Inactive MASS Data",
        inactive_report_filename: "inactive_mass_report",
        detailed_account_status_title: "Detailed Account Status",
        detailed_account_status_sheet_name: "Account Status Data",
        detailed_account_status_filename: "account_status_report",
        filter_title: "Filter",
        date_range_label: "Date Range",
        filter_by_label: "Filter By",
        release_date: "Release Date",
        end_date: "End Date",
        consumption_label: "Consumption",
        all_consumption: "All",
        consumption_0_50: "0-50%",
        consumption_50_80: "50-80%",
        consumption_80_100: "80-100%",
        clear_filter: "Clear Filter",
        filter_by_date:"Filter by Date",
        consumption_range:"Consumption Range",
        auto_debit_success:"Auto Debit Success!",

        //Invoice Label
        my_invoices_label: "My Invoices",
        total_invoices_label: "Total",
        invoices_to_download: "invoices to download",
        invoice_number_label: "Invoice Number",
        transaction_id_label: "Transaction ID",
        billing_date_label: "Billing Date",
        plan_label: "Plan",
        amount_label: "Amount",
        download_label: "Download",
        downloading_label: "Downloading",
        pending_status_label: "Pending",
        pro_plan_names: "Pro",

      },
    },
    hi: {
      translation: {
        welcome: "स्वागत है",
        service_insights: "सेवा अंतर्दृष्टि",
        confirmed: "पुष्टि की गई",
        cancelled: "रद्द किया गया",
        smr_bots: "एसएमआर बॉट्स",
        psf_bots: "पीएसएफ बॉट्स",
        abc_bots: "एबीसी बॉट्स",
        active_service: "सक्रिय सेवा",
        other_service: "अन्य सेवा",
        view_details: "विवरण देखें",
        smr_bots_title: "एसएमआर + बॉट्स (चैट + वॉयस)",
        smr_bots_description:
          "जब आप हमारे होम पेज पर आते हैं, तो एसएमआर बॉट्स पॉप अप होते हैं और यदि आप एसएमआर के साथ काम करने में रुचि रखते हैं, तो वह आपको एक लाइव एजेंट से जोड़ देती है। एजेंट को मेरे कैलेंडर की वास्तविक समय की पहुंच होती है और वह हमारे लिए वहीं और तब अपॉइंटमेंट निर्धारित कर सकता है।",
        psf_bots_title: "पीएसएफ + बॉट्स (चैट + वॉयस)",
        psf_bots_description:
          "जब आप हमारे होम पेज पर आते हैं, तो एसएमआर बॉट्स पॉप अप होते हैं और यदि आप एसएमआर के साथ काम करने में रुचि रखते हैं, तो वह आपको एक लाइव एजेंट से जोड़ देती है। एजेंट को मेरे कैलेंडर की वास्तविक समय की पहुंच होती है और वह हमारे लिए वहीं और तब अपॉइंटमेंट निर्धारित कर सकता है।",
        all_in_one_service_plans: "सब-इन-वन सेवा योजनाएं",
        home_account_details: "खाता विवरण",
        total_active_service_plans: "कुल {{count}} सक्रिय सेवा योजनाएं",
        total_other_service_plans: "कुल {{count}} अन्य सेवा योजनाएँ",
        home: "होम",
        active_services: "सक्रिय सेवाएं",
        other_services: "अन्य सेवाएं",
        available_balance: "उपलब्ध शेष राशि",
        showing_data: "दिखा रहा है",
        to: "से",
        entries: "प्रविष्टियाँ",
        plan_name: "सेवा का नाम",


        //Service Page
        key_features: "मुख्य विशेषताएँ",
        our_top_benefits: "हमारे शीर्ष लाभ",
        service_overview: "सेवा का अवलोकन",
        service_amount: "सेवा राशि",
        service_status: "सेवा की स्थिति",
        report_s: "रिपोर्ट",
        invoice_s: "चालान",
        learn_more: "और जानें",
        smr_bots_key_features:
          "आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।",
        smr_bots_top_benefits:
          "AI चैट बॉट मानव विशेषज्ञता की आवश्यकता होने पर बातचीत को लाइव एजेंट को स्थानांतरित करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।",
        psf_bots_key_features:
          "आपका व्यवसाय एक AI चैट बॉट के साथ सशक्त करें जो कई भाषाओं में बात करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।",
        psf_bots_top_benefits:
          "AI चैट बॉट लाइव एजेंट से सुचारू रूप से जुड़ता है।AI चैट बॉट मानव विशेषज्ञता की आवश्यकता होने पर बातचीत को लाइव एजेंट को स्थानांतरित करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।आपका व्यवसाय एक बहुभाषी AI चैट बॉट के साथ सशक्त करें। यह एकीकृत इनबॉक्स में सभी चैनलों से संदेश एकत्र करता है।",
        service_amount_title: "कुल {{count}} सेवा योजनाएं",
        sorting: "क्रमबद्ध करें",
        cost_low_to_high: "मूल्य (निम्न से उच्च)",
        cost_high_to_low: "मूल्य (उच्च से निम्न)",
        minutes_low_to_high: "मिनट (निम्न से उच्च)",
        minutes_high_to_low: "मिनट (उच्च से निम्न)",
        chats_low_to_high: "चैट्स (निम्न से उच्च)",
        chats_high_to_low: "चैट्स (उच्च से निम्न)",
        plan_cost: "योजना लागत",
        total_minutes: "कुल मिनट",
        whatsapp_chats: "व्हाट्सएप चैट्स",
        add_service: "सेवा जोड़ें",
        registerAutoDebit: "ऑटो-डेबिट के लिए पंजीकरण करें?",
        confirmationText: "यह पुष्टि है कि आपने ऑटो-डेबिट के लिए पंजीकरण कर लिया है। क्या आप जारी रखना चाहते हैं?",
        keepManual: "इसे मैनुअल रखें",
         autoDebitSuccessTitl: "ऑटो डेबिट सफल!",
  autoDebitSuccessMessage: "आपका ऑटो डेबिट पंजीकरण सफलतापूर्वक पूरा हो गया है।",
  alert: "चेतावनी",
disableAutoDebitMessage: "नए योजना को सक्षम करने से पहले ऑटो डेबिट को अक्षम करें।",
  okButton: "ठीक है",

        //Purchase Popup
        tax_invoice: "{{planName}} का कर चालान!",
        service_plan: "सेवा योजना",
        service_name: "सेवा का नाम",
        purchase_date: "खरीद की तारीख",
        invoice_country: "चालान देश",
        country_name: "भारत",
        unit_price: "यूनिट मूल्य",
        gst_percentage: "जीएसटी%",
        gst_amount: "जीएसटी राशि",
        total_amount: "कुल राशि",
        cancel: "रद्द करें",
        confirm: "पुष्टि करें",
        no_data_found:"कोई डेटा नहीं मिला",

        //Terms & Conditions
        terms_conditions: "नियम एवं शर्तें",
        terms_paragraph:
          '{\n  "sections": [\n    {\n      "title": "1. परिचय और परिभाषाएँ",      "content": [\n        "मारुति सुजुकी इंडिया लिमिटेड (आगे \'MSIL\' कहा जाएगा) मारुति सुजुकी अधिकृत सेवा स्टेशनों (आगे \'MASS\' कहा जाएगा) के लिए MASS बिजनेस ज़ोन पोर्टल (पोर्टल) के माध्यम से डिजिटल सेवाओं की प्रीपेड सदस्यता योजनाएँ प्रदान करता है।"\n      ]\n    },\n    {\n      "title": "2. सेवाओं का उद्देश्य और स्वीकृति",\n      "content": [\n        "MASS समझता है और सहमत होता है कि इन सेवाओं का उद्देश्य MASS कार्यशाला व्यापार संचालन को डिजिटल रूप से समर्थन देना है।"\n      ]\n    },\n    {\n      "title": "3. भुगतान और कटौती के लिए प्राधिकरण",\n      "content": [\n        "MASS सहमत होता है और MSIL को MASS के वित्तीय खातों से धनराशि काटने और चयनित सेवा पैकेज एवं लागू करों के आधार पर किसी भी समय MASS की ओर से सेवाएँ संचालित करने की अनुमति देता है।"\n      ]\n    },\n    {\n      "title": "4. सेवा संचालन और समाप्ति",\n      "content": [\n        "MASS, MSIL को अपने व्यावसायिक भागीदारों/विक्रेताओं को MASS द्वारा चयनित सदस्यता के अनुसार डिजिटल सेवाएँ संचालित करने की अनुमति देता है।",\n        "MASS सहमत होता है कि एक बार सदस्यता लेने के बाद सेवाओं को रोकना, निलंबित करना, या समाप्त करना संभव नहीं होगा जब तक कि सेवा की अवधि पूरी न हो जाए।",\n        "हालांकि, MSIL को किसी भी समय बिना किसी पूर्व सूचना के सेवाओं को समाप्त करने का अधिकार सुरक्षित है।"\n      ]\n    },\n    {\n      "title": "5. सेवा नियम, समय-सारिणी और संशोधन",\n      "content": [\n        "MASS डिजिटल सेवाओं को MSIL के विवेक पर नियमों, समय-सारिणी और प्रक्रियाओं के अनुसार संचालित करने के लिए स्वीकार करता है।",\n        "इसके अतिरिक्त, MBZ पोर्टल का हिस्सा होने के नाते, MASS सहमत होता है कि किसी भी समय, बिना किसी सूचना के, MSIL द्वारा नियमों, समय-सारिणी और प्रक्रियाओं में किए गए किसी भी परिवर्तन/संशोधन को स्वीकार करेगा।"\n      ]\n    },\n    {\n      "title": "6. सेवा नवीनीकरण",\n      "content": [\n        "चयनित सेवा पैकेज के आधार पर, MASS, MSIL को सभी लागू डेबिट शुल्कों के साथ सेवाओं को नवीनीकृत करने की अनुमति देगा जब तक कि MASS स्वयं मैन्युअल रूप से बाहर निकलने का निर्णय न ले।"\n      ]\n    },\n    {\n      "title": "7. वॉयस और चैट बॉट सेवाओं का दायरा",\n      "content": [\n        "वॉयस + चैट बॉट उन सभी ग्राहकों को कॉल करेगा जिनका SMR/सेवा बकाया है या जिनका वैध मोबाइल नंबर डीलर प्रबंधन प्रणाली सॉफ्टवेयर (DMS) में उपलब्ध है, जब तक कि यह योजना सक्रिय है।"\n      ]\n    },\n    {\n      "title": "8. लीड और फीडबैक साझाकरण",\n      "content": [\n        "उत्पन्न लीड/प्रतिक्रिया MASS को DMS प्रणाली या MSIL द्वारा साझा किए गए किसी भी पोर्टल पर साझा की जाएगी, लेकिन MBZ पोर्टल पर नहीं।"\n      ]\n    },\n    {\n      "title": "9. डेटा विश्लेषण और ग्राहक संपर्क प्राधिकरण",\n      "content": [\n        "MASS सहमत होता है कि उसके डेटाबेस का विश्लेषण किया जा सकता है और AI-आधारित वॉयस + चैट बॉट प्रणाली द्वारा गतिविधि के दौरान ग्राहकों से संपर्क किया जा सकता है।"\n      ]\n    },\n    {\n      "title": "10. प्रदर्शन अस्वीकरण",\n      "content": [\n        "MASS समझता है और स्वीकार करता है कि चैट/वॉयस बॉट्स का प्रदर्शन और उत्पन्न लीड/प्रतिक्रिया ग्राहकों की प्रतिक्रियाओं पर निर्भर करती है।",\n        "चूंकि प्रदर्शन डेटाबेस की गुणवत्ता पर निर्भर करता है, MSIL किसी भी समय डिजिटल सेवाओं के प्रदर्शन की कोई गारंटी नहीं देता है।",\n        "MASS स्वीकार करता है कि डिजिटल प्रणाली की विफलता के कारण होने वाली किसी भी घटना या क्षति की पूरी जिम्मेदारी MASS की होगी।"\n      ]\n    }, \n    {\n      "title": "11. अभियान प्रस्ताव अपडेट",\n      "content": [\n        "इस गतिविधि के लिए, MASS अपने समर्पित अभियान पोर्टल्स पर ऑफ़र अपडेट कर सकता है, जो MSIL द्वारा MASS के लिए साझा किए गए हैं।"\n      ]\n    },\n    {\n      "title": "12. लीड और फीडबैक के लिए MASS की जिम्मेदारी",\n      "content": [\n        "MASS समझता है और सहमत होता है कि वॉयस + चैट बॉट द्वारा उत्पन्न लीड/प्रतिक्रिया इसके सेवा व्यवसाय भार, राजस्व और ग्राहक संतुष्टि को बढ़ाने में सहायक होगी।",\n        "हालांकि, प्राप्त प्रतिक्रियाओं, फॉलो-अप और लीड के रूपांतरण/प्रतिक्रिया चिंताओं के समाधान की पूरी जिम्मेदारी MASS की होगी।"\n      ]\n    },\n    {\n      "title": "13. MSIL का अभियान विवरण संशोधित करने का अधिकार",\n      "content": [\n        "MSIL को किसी भी समय बिना किसी पूर्व सूचना के अपने विवेक पर डेटा, नियम और शर्तें, विवरण और अभियान की अवधि को बदलने का अधिकार सुरक्षित है।"\n      ]\n    },\n    {\n      "title": "14. कानूनों और विनियमों का अनुपालन",\n      "content": [\n        "TRAI, टेलीकॉम कंपनियों और META (व्हाट्सएप) विनियमों सहित सभी लागू कानूनों का अनुपालन उन MASS द्वारा किया जाना चाहिए जो सेवाएँ प्राप्त कर रहे हैं।",\n        "नियामक प्राधिकरणों से उत्पन्न किसी भी प्रश्न/विवाद को MASS द्वारा हल किया जाएगा।"\n      ]\n    },\n    {\n      "title": "15. प्रश्न और सहायता संपर्क",\n      "content": [\n        "MASS को यदि कोई संदेह/प्रश्न हो तो उसे MSIL क्षेत्रीय कार्यालयों/सेवा टीमों से चर्चा करनी होगी।"\n      ]\n    },\n    {\n      "title": "16. सामान्य प्रयोज्यता और संपर्क जानकारी",\n      "content": [\n        "ये ऑफ़र दोनों चैट और वॉयस बॉट के लिए लागू होंगे।",\n        "किसी भी प्रश्न के लिए कृपया अपने MSIL क्षेत्रीय कार्यालय से संपर्क करें।"\n      ]\n    },\n    {\n      "title": "17. डू नॉट डिस्टर्ब (परेशान न करें) पंजीकरण",\n      "content": [\n        "सेवा विपणन कॉल/चैट को रोकने के लिए किसी भी फोन नंबर को \'डू नॉट डिस्टर्ब\' में चिह्नित करने के लिए ग्राहक विवरण और फोन नंबर cs@rezo.ai और support@rezo.ai पर ईमेल करें।"\n      ]\n    },\n    {\n      "title": "18. सामान्य कानूनी प्रावधान",\n      "content": [\n        "MASS सभी लागू डेटा गोपनीयता और सुरक्षा नियमों का पालन करने और डिजिटल स्रोतों से प्राप्त सभी जानकारी की गोपनीयता, सुरक्षा, और अखंडता बनाए रखने के लिए जिम्मेदार होगा।",\n        "MASS सेवाओं से उत्पन्न होने वाले किसी भी विवाद से MSIL को मुक्त करेगा।",\n        "इन नियमों और शर्तों के तहत सेवाओं से उत्पन्न किसी भी विवाद की स्थिति में, MASS समझौते के तहत सहमत नियम और शर्तें लागू होंगी।",\n        "MSIL किसी भी समय बिना किसी पूर्व सूचना के इन नियमों और शर्तों में बदलाव कर सकता है।",\n        "इन्हें संदर्भ के लिए पोर्टल में अपडेट किया जाएगा।"\n      ]\n    }\n  ]\n}',
        agree_terms: "मैंने नियम और शर्तें पढ़ी और सहमत हूँ",
        accept: "स्वीकार करें",

        //OrderConfirmationPopup
        thank_you_order:
          "आपके ऑर्डर के लिए धन्यवाद। आपकी सेवा जल्द ही शुरू होगी!",
        order_details: "ऑर्डर विवरण",
        service_purchased: "सेवा खरीदी गई",
        connected_total_minutes: "कुल मिनट जुड़े हुए",
        minutes: "मिनट",
        whatsapp: "व्हाट्सएप",
        chat: "चैट",
        order_id: "ऑर्डर आईडी",
        order_date: "ऑर्डर की तारीख",
        order_number: "ऑर्डर नंबर",
        total_cost: "कुल लागत",

        //Service Status
        current_service_status: "वर्तमान सेवा स्थिति",
        recharge_plan_name: "रिचार्ज योजना का नाम",
        total_connected_call_minutes: "जुड़ा कॉल (मिनट) / कुल",
        total_delivered_chats: "वितरित (चैट) / कुल",
        pro_plan_name: "प्रो योजना",
        balance_call: "शेष राशि (कॉल)",
        balance_chats: "शेष राशि (चैट)",
        minutes_left: "कुल {{total}} मिनट शेष",
        chats_left: "कुल {{total}} चैट्स शेष",
        out_of_total: "कुल में से ",
        chats: "चैट्स",

        //recent transaction reports
        transaction_reports: "लेनदेन रिपोर्ट",
    date_start: "शुरुआत की तारीख",
    date_end: "आखिरी तारीख",
    all_services: "सभी सेवाएं",
    view_report: "रिपोर्ट देखें",
    export_to_excel: "निर्यात करें",
    export_to_pdf: "निर्यात करें",
    transaction_summary: "लेनदेन सारांश ",
    all_dates: "सभी तिथियां",
    for_service: "सेवा के लिए",
    transaction_date: "लेनदेन की तारीख",
    transaction_id: "लेनदेन आईडी",
    plan: "योजना",
    gst: "जीएसटी",
    amount: "राशि",
    total_debit: "कुल डेबिट",
    closing_balance: "शेष राशि",
    auto_debit: "ऑटो डेबिट",
    previous: "पिछला",
    next: "अगला",
    no_data_export: "निर्यात करने के लिए कोई डेटा उपलब्ध नहीं है।",
    transaction_report_title: "लेनदेन रिपोर्ट",
    amount_currency: "राशि (₹)",
    total_debit_currency: "कुल डेबिट (₹)",
    closing_balance_currency: "शेष राशि (₹)",
    select_date_range: "तारीख़ सीमा चुनें",
     date_range: "तिथि सीमा",
     all_plans: "सभी योजनाएं",

     //Admin Dashboard

  "TOTAL_MASS_DMS": "कुल मास (DMS)",
  "VIEW_TOTAL_MASS_USERS_DMS": "कुल मास उपयोगकर्ता देखें (DMS)",
  "TOTAL_ONBOARDED_MASS": "कुल ऑनबोर्डेड मास",
  "VIEW_TOTAL_ONBOARDED_MASS": "कुल ऑनबोर्डेड मास देखें",
  "UP_FROM_LAST_MONTH": "▲ पिछले महीने से 2.7% ऊपर",
  "TOTAL_MASS_ACTIVE": "कुल मास (सक्रिय सेवा)",
  "VIEW_ALL_ACTIVE": "सभी सक्रिय मास उपयोगकर्ताओं को देखें",
  "PENDING_REQUESTS": "लंबित अनुरोध",
  "MANAGE_REQUESTS": "अनुरोध प्रबंधित करें",
  "SERVICE_ABOUT_TO_EXHAUST": "सेवा समाप्ति के करीब सभी मास",
  "VIEW_SERVICE_ABOUT_TO_EXHAUST": "सेवा समाप्ति के करीब मास देखें",
  "ACTIVE_SERVICE_PLANS": "सक्रिय सेवा योजनाएं",
  "VIEW_ALL_SERVICE_PLANS": "सभी सेवा योजनाएं देखें",
  "TOTAL_REVENUE": "कुल राजस्व",
  "VIEW_REPORT": "रिपोर्ट देखें",
  "UP_FROM_LAST_QUARTER": "▲ पिछले तिमाही से 1.6% ऊपर",

//Admin all services
 "allServices": "सभी सेवाएँ",
  "status": "स्थिति",
  "all": "सभी",
  "active": "सक्रिय",
  "inactive": "निष्क्रिय",
  "serviceName": "सेवा का नाम",
  "servicePlan": "सेवा योजना",
  "basic": "मूल",
  "basicPlusPlus": "मूल ++",
  "proPlan": "प्रो योजना",
  "categories": "श्रेणियाँ",
  "addService": "सेवा जोड़ें",
  "serviceInfo": "सेवा जानकारी",
  "editServices": "सेवाएं संपादित करें",
  "deactivate": "निष्क्रिय करें",
  "category": "श्रेणी",
  "activationDate": "सक्रियकरण तिथि",
  "plans": "योजनाएँ",
  "priceInclGST": "मूल्य (जीएसटी सहित)",
  "planStatus": "योजना की स्थिति",
  "showingData": "{{start}} से {{end}} प्रविष्टियाँ दिखा रहा है",
  "aichatbot": "एआई चैटबॉट",
  "voicechatbot": "वॉयस चैटबॉट",
  "chatbot": "चैटबॉट",
  "smschatbot": "एसएमएस चैटबॉट",
  "smrchatbot": "एसएमआर चैटबॉट",
  "edit": "संपादित करें",
  "editPlan": "योजना संपादित करें",
  "deletePlan": "योजना हटाएं",
  "deleteService": "सेवा हटाएं",



  //Add new Service
  "ADD_NEW_SERVICE_TITLE": "नई सेवा जोड़ें",
  "SERVICE_DETAILS": "सेवा विवरण",
  "SERVICE_PLANS": "सेवा योजनाएँ",
  "ADD_PLANS_BUTTON": "+ योजनाएँ जोड़ें",
  "BACK_BUTTON": "पीछे",
  "SERVICE_DETAIL_INFORMATION_TITLE": "सेवा विवरण जानकारी",
  "SERVICE_NAME_LABEL": "सेवा का नाम",
  "SERVICE_NAME_REQUIRED": "सेवा का नाम आवश्यक है।",
  "SERVICE_NAME_TEXT_ONLY": "कृपया केवल पाठ (अक्षर और स्थान) दर्ज करें।",
  "SERVICE_CATEGORY_LABEL": "सेवा श्रेणी",
  "SERVICE_CATEGORY_REQUIRED": "सेवा श्रेणी आवश्यक है।",
  "SELECT_CATEGORY_OPTION": "एक श्रेणी चुनें",
  "DETAILED_DESCRIPTION_LABEL": "विस्तृत विवरण",
  "DETAILED_DESCRIPTION_PLACEHOLDER": "सेवा का विस्तृत विवरण ग्राहकों को सेवा के बारे में अधिक जानने में मदद करता है।",
  "DETAILED_DESCRIPTION_REQUIRED": "विस्तृत विवरण आवश्यक है।",
  "KEY_FEATURES_LABEL": "मुख्य विशेषताएँ",
  "KEY_FEATURES_PLACEHOLDER": "सेवा की विस्तृत मुख्य विशेषताएँ ग्राहकों को सेवा के बारे में अधिक जानने में मदद करती हैं।",
  "KEY_FEATURES_REQUIRED": "मुख्य विशेषताएँ आवश्यक हैं",
  "TOP_BENEFITS_LABEL": "शीर्ष लाभ",
  "TOP_BENEFITS_PLACEHOLDER": "सेवा के विस्तृत शीर्ष लाभ ग्राहकों को सेवा के बारे में अधिक जानने में मदद करते हैं।",
  "TOP_BENEFITS_REQUIRED": "शीर्ष लाभ आवश्यक हैं",
  "CANCEL_BUTTON": "रद्द करें",
  "DRAFT_BUTTON": "ड्राफ्ट",
  "CONTINUE_BUTTON": "जारी रखें",
  "DRAFTING_SERVICE": "सेवा का ड्राफ्ट तैयार कर रहे हैं:",
  "PUBLISHING_SERVICE": "सेवा प्रकाशित कर रहे हैं:",

    "revenueFY": "राजस्व वित्तीय वर्ष {{year}}",
  "month": "महीना",
  "quarter": "त्रैमासिक",
  "lineChart": "लाइन चार्ट",
  "barChart": "बार चार्ट",
  "tooltipLabel": "{{label}}: ₹{{value}}",


  //Add service plan
    "servicePlanInformation": "सेवा योजना की जानकारी",
  "planName": "योजना का नाम",
  "planNameRequired": "योजना का नाम आवश्यक है",
  "planNameTextOnly": "कृपया केवल टेक्स्ट दर्ज करें",
  "totalCallingMinutes": "कुल कॉलिंग मिनट",
  "totalMessages": "कुल संदेश",
  "productPrice": "उत्पाद मूल्य",
  "productPriceRequired": "उत्पाद मूल्य आवश्यक है और यह एक पूर्ण संख्या होनी चाहिए।",
  "draft": "ड्राफ्ट",
  "publish": "प्रकाशित करें",
   "denied": "अस्वीकृत",


  //Admin notification page
  "notificationsSettings": "सूचना सेटिंग",
  "serviceUsageNotification": "जब सेवा का उपयोग इसके बीच हो तो MASS ADMIN को एक सूचना संदेश प्राप्त होगा:",
  "percentageRange30_49": "30% से 49%",
  "percentageRange50_89": "50% से 89%",
  "percentageRange90_100": "90% से 100%",
  "email": "ईमेल",
  "sms": "एसएमएस",
  "save": "सहेजें",
  "subscriptionRequestNotification": "जब सदस्यता अनुरोध हो तो MASS ADMIN को एक सूचना संदेश प्राप्त होगा:",
  "approved": "अनुमोदित",
  "pending": "विचाराधीन",
  "rejected": "अस्वीकृत",


  //Offers and promotions
  "offersAndPromotions": "ऑफ़र और प्रचार",
  "images": "छवियाँ",
  "videos": "वीडियो",
  "offersAndPromotionCaption": "ऑफ़र और प्रचार कैप्शन",
  "chatBot": "चैट बॉट",
  "newOffer": "नया ऑफ़र!",
  "limitedTimePromotion": "सीमित समय का प्रचार",
  "selectAndUploadImage": "छवि चुनें और अपलोड करें",
  "chooseFileAndDropHere": "एक फ़ाइल चुनें और यहाँ खींचें",
  "imageFileRequirements": "केवल .jpeg, .jpg, PDF फ़ाइलें। अधिकतम आकार: 5MB।",
  "browseFile": "फ़ाइल ब्राउज़ करें",
  "upload": "अपलोड करें",
  "uploadedImage": "अपलोड की गई छवि",
  "noImageUploadedYet": "अभी तक कोई छवि अपलोड नहीं की गई है।",
  "continue": "जारी रखें",
  "captionRequired": "कृपया एक कैप्शन चुनें।",
  "imageUploadRequired": "कृपया अपलोड करने के लिए एक छवि चुनें।",
  "invalidFileTypeOrSize": "अमान्य फ़ाइल प्रकार या आकार। केवल .jpeg, .jpg, और .png फ़ाइलें 5MB तक अनुमत हैं।",
  "uploadImageToSaveDraft": "ड्राफ्ट के रूप में सहेजने के लिए कृपया एक छवि अपलोड करें।",
  "uploadImageToContinue": "जारी रखने के लिए कृपया एक छवि अपलोड करें।",
  "bytes": "बाइट्स",
  "kb": "केबी",
  "mb": "एमबी",
  "gb": "जीबी",
  "tb": "टीबी",


  //Offer and promotion video
  "videoType": "वीडियो प्रकार",
  "selectVideoType": "वीडियो प्रकार चुनें",
  "youtube": "यूट्यूब",
  "enterVideoURL": "वीडियो यूआरएल दर्ज करें",
  "videoTypeRequired": "कृपया एक वीडियो प्रकार चुनें।",
  "youtubeURLRequired": "यूट्यूब के लिए कृपया एक वीडियो यूआरएल दर्ज करें।",
  "fileOrURLRequired": "कृपया एक वीडियो फ़ाइल अपलोड करें या एक वीडियो यूआरएल दर्ज करें।",
  "correctErrorsBelow": "कृपया नीचे दी गई त्रुटियों को ठीक करें।",
  "publishedSuccessful": "सफलतापूर्वक प्रकाशित!",
  "noVideoUploadedYet": "अभी तक कोई वीडियो अपलोड नहीं किया गया है।",
  "videoFileRequirements": "केवल .mp4, .mov फ़ाइलें। अधिकतम आकार: 10MB।",
  "selectFileToUpload": "कृपया अपलोड करने के लिए एक फ़ाइल चुनें।",
  selectAndUploadVideo:"वीडियो चुनें और अपलोड करें",
  uploadedVideo:"Uploaded Video",
  "dashboard": "डैशबोर्ड",
  "services": "सेवाएँ",
  "reports": "रिपोर्टें",
  "notifications": "सूचनाएँ",
   "pendingOnboardingRequests": "लंबित ऑनबोर्डिंग अनुरोध",
  "massName": "मास नाम",
  "massCode": "मास कोड",
  "region": "क्षेत्र",
  "onboardingDate": "ऑनबोर्डिंग दिनांक",
  "actions": "कार्य",
  "approve": "अनुमोदित करें",
  "deny": "अस्वीकार करें",
  "approveAll": "सभी को अनुमोदित करें",
  "denyAll": "सभी को अस्वीकार करें",
  "noPendingRequests": "कोई लंबित ऑनबोर्डिंग अनुरोध नहीं।",
  "viewAllRequests": "सभी अनुरोध देखें",
  "approveUsers": "उपयोगकर्ता(ओं) को अनुमोदित करें?",
  "denyUsers": "उपयोगकर्ता(ओं) को अस्वीकार करें?",
  "requestsSelected": "{{count}} अनुरोध चयनित।",
  "requestsSelectedPlural": "{{count}} अनुरोध चयनित।",
  "doYouWantTo": "क्या आप {{actionType}} करना चाहते हैं?",

    serviceCategory: "सेवा श्रेणी",
    detailedDescription: "विस्तृत विवरण",
    keyFeatures: "मुख्य विशेषताएँ",
    topBenefits: "शीर्ष लाभ",
    serviceNameRequired: "सेवा का नाम आवश्यक है।",
    serviceNameTextOnly: "कृपया केवल टेक्स्ट (अक्षर और रिक्त स्थान) दर्ज करें।",
    serviceCategoryRequired: "सेवा श्रेणी आवश्यक है।",
    detailedDescriptionRequired: "विस्तृत विवरण आवश्यक है।",
    keyFeaturesRequired: "मुख्य विशेषताएँ आवश्यक हैं।",
    topBenefitsRequired: "शीर्ष लाभ आवश्यक हैं।",
    addNewService: "नई सेवा जोड़ें",
    serviceDetails: "सेवा विवरण",
    servicePlans: "सेवा योजनाएँ",
    addPlans: "+ योजनाएँ जोड़ें",
    addPlan: " योजनाएँ जोड़ें",
    back: "पीछे",
    serviceDetailInformation: "सेवा विवरण जानकारी",
    placeholderDescription: "सेवा का विस्तृत विवरण ग्राहकों को सेवा के बारे में अधिक जानने में मदद करता है।",
    placeholderKeyFeatures: "सेवा की विस्तृत मुख्य विशेषताएँ ग्राहकों को सेवा के बारे में अधिक जानने में मदद करती हैं।",
    placeholderTopBenefits: "सेवा के विस्तृत शीर्ष लाभ ग्राहकों को सेवा के बारे में अधिक जानने में मदद करते हैं।",
    selectCategory: "एक श्रेणी चुनें",


        //Report
        report_type_label: "रिपोर्ट प्रकार:",
        usage_reports_option: "उपयोग रिपोर्ट्स",
        apply_button: "लागू करें",
        serial_no_label: "क्रम",
        plan_name_label: "योजना का नाम",
        cost_of_plan_label: "योजना की लागत",
        initial_recharge_label: "प्रारंभिक रिचार्ज",
        usage_label: "उपयोग",
        balance_label: "शेष",
        usage_report_title: "उपयोग रिपोर्ट",
        usage_report_filename: "उपयोग रिपोर्ट",
        usage_report_sheet_name: "उपयोग रिपोर्ट",
        date_format: "dd MMM yyyy",
        performance_report_data: "प्रदर्शन रिपोर्ट डेटा",
        no_data_available: "इस रिपोर्ट प्रकार के लिए कोई डेटा उपलब्ध नहीं है",
        basic_plan_name: "बेसिक",
        basic_plus_plan_name: "बेसिक ++",
        usage_reports_label: "उपयोग रिपोर्ट",
        pro_plus_plan_name: "प्रो ++",
        minutes_label: "{{value}} मिनट",
        no_data_export_message: "कोई डेटा नहीं मिला",
        report_titles: {
          usage_reports: "उपयोग रिपोर्ट",
          performance_report: "Performance Report",
        },

        service_usage_report: "सेवा उपयोग रिपोर्ट",
        inactive_mass_report: "निष्क्रिय एमएएस रिपोर्ट",
        detailed_account_status: "विस्तृत खाता स्थिति",
        financial_report: "वित्तीय रिपोर्ट",
        financial_report_mass_code: "एमएएस कोड",
        financial_report_mass_name: "एमएएस नाम",
        financial_report_service_name: "सेवा नाम",
        financial_report_invoice_number: "चालान संख्या",
        financial_report_invoice_date: "चालान तिथि",
        financial_report_basic_amount: "मूल राशि",
        financial_report_igst_amount: "आईजीएसटी राशि",
        financial_report_sgst_amount: "एसजीएसटी राशि",
        financial_report_cgst_amount: "सीजीएसटी राशि",
        financial_report_total_amount: "कुल राशि",
        financial_report_gst_number: "एमएएस का जीएसटी नंबर",
        financial_report_plan_name: "योजना नाम",
        financial_report_plan_value: "योजना मूल्य",
        financial_report_plan_date: "योजना तिथि",
        financial_report_minutes_provided: "प्रदान किए गए मिनट",
        financial_report_messages_provided: "प्रदान किए गए संदेश",
        financial_report_sheet_name: "वित्तीय रिपोर्ट डेटा",
        financial_report_filename: "वित्तीय_रिपोर्ट",

        mass_name_label: "एमएएस नाम",
        mobile_label: "मोबाइल",
        region_label: "क्षेत्र",
        service_name_label: "सेवा का नाम",

        mass_code_label: "एमएएस कोड",
        status_label: "स्थिति",
        order_date_label: "आदेश तिथि",
        release_date_label: "रिलीज़ तिथि",
        end_date_label: "अंतिम तिथि",
        price_label: "मूल्य",
        auto_debit_label: "स्वतः डेबिट",
        yes: "हाँ",
        no: "नहीं",
        last_activity_label: "अंतिम गतिविधि",
        inactivity_reason_label: "निष्क्रियता कारण",
        no_activity: "कोई गतिविधि नहीं",
        account_balance_label: "खाता शेष",
        account_balance_timestamped_label: "खाता शेष (समय के साथ)",
        no_of_active_services_label: "सक्रिय सेवाओं की संख्या",
        services_report_title: "सेवाएं रिपोर्ट",
        services_report_sheet_name: "सेवाएं डेटा",
        services_report_filename: "सेवाएं_रिपोर्ट",
        inactive_report_title: "निष्क्रिय एमएएस रिपोर्ट",
        inactive_report_sheet_name: "निष्क्रिय एमएएस डेटा",
        inactive_report_filename: "निष्क्रिय_एमएएस_रिपोर्ट",
        detailed_account_status_title: "विस्तृत खाता स्थिति",
        detailed_account_status_sheet_name: "खाता स्थिति डेटा",
        detailed_account_status_filename: "खाता_स्थिति_रिपोर्ट",
        filter_title: "फ़िल्टर",
        date_range_label: "तिथि सीमा",
        filter_by_label: "इसके द्वारा फ़िल्टर करें",
        release_date: "रिलीज़ तिथि",
        end_date: "अंतिम तिथि",
        consumption_label: "खपत",
        all_consumption: "सभी",
        consumption_0_50: "0-50%",
        consumption_50_80: "50-80%",
        consumption_80_100: "80-100%",
        clear_filter: "फ़िल्टर साफ़ करें",
        filter_by_date:"दिनांक द्वारा छाँटें",
        consumption_range:"खपत सीमा",
  autoDebitSuccessTitle: "ऑटो डेबिट सफल!",




        //Invoice
        my_invoices_label: "मेरे चालान",
        total_invoices_label: "कुल",
        invoices_to_download: "चालान डाउनलोड करने के लिए",
        invoice_number_label: "चालान संख्या",
        transaction_id_label: "लेन-देन आईडी",
        billing_date_label: "बिलिंग तिथि",
        plan_label: "योजना",
        amount_label: "राशि",
        download_label: "डाउनलोड करें",
        downloading_label: "डाउनलोड हो रहा है",
        pending_status_label: "लंबित",
        pro_plan_names: "प्रो",
      },
    },
  },
  lng: "en", // Default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export { i18n }; // Export as named export
